var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',[_vm._v("Speak into the microphone. The current transcription is shown on screen.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }